import { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import ModelsContext from '../contexts/ModelsContext';
import create from '../_blueprints/create';
import update from '../_blueprints/update';
import updateDynamic from '../_blueprints/updateDynamic';
import updateSingleton from '../_blueprints/updateSingleton';
import destroy from '../_blueprints/destroy';
import destroyDynamic from '../_blueprints/destroyDynamic';

export function useQueryMutation(key, currentPayload, extra = {}) {
  const models = useContext(ModelsContext);
  const queryClient = useQueryClient();

  const [model, method] = key.split('.');

  const Model = models[model];

  const blueprint = {
    create: create,
    update: update,
    updateDynamic: updateDynamic,
    updateSingleton: updateSingleton,
    destroy: destroy,
    destroyDynamic: destroyDynamic,
    destroy2: destroyDynamic  // alias for destroyDynamic — prefer destroyDynamic in new code
  }[method];

  const mutationParams = blueprint(key, {
    Model,
    queryClient,
    modelName: model,
    currentPayload: currentPayload
  });

  const mutation = useMutation({
    ...mutationParams,
    ...extra
  });

  // console.log('useMutation:after');
  // console.log(mutation);

  return {
    ...mutation,
    saving: mutation.isLoading,
    success: mutation.isSuccess,
    request: (
      mutation.isLoading ? mutation.context?.optimisticPayload :
      mutation.isError ? mutation.error :
      mutation.isSuccess ? mutation.data :
      null
    )
  };

  // return {
  //   ...(mutation.error || mutation.data),
  //   _isLoading: mutation.isLoading,
  //   _isError: mutation.isError,
  //   _isSuccess: mutation.isSuccess
  // };
}
